import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export function ProtectedRoute({ children, requireOrg = true }) {
    const { user, currentOrg, loading } = useAuth();
    if (loading || user === undefined) {
        return (
            <div className="min-h-screen grid place-items-center bg-ocean-mesh">
                <div className="h-10 w-10 rounded-full border-2 border-secondary border-t-transparent animate-spin" />
            </div>
        );
    }
    if (!user) return <Navigate to="/login" replace />;
    if (requireOrg && !currentOrg) return <Navigate to="/onboarding" replace />;
    return children;
}

export default ProtectedRoute;
